import React from "react";
import PropTypes from "prop-types";
import Autocomplete from "react-autocomplete";
import "./siteList.scss";

const SiteList = ({ siteList, siteDns, onSiteSelect }) => {
  return (
    <div className="site-list">
      <Autocomplete
        inputProps={{ placeholder: "Enter site dns" }}
        getItemValue={item => Object.keys(item)[0]}
        items={siteList}
        shouldItemRender={(item, value) =>
          Object.keys(item)[0]
            .toLowerCase()
            .indexOf(value.toLowerCase()) > -1
        }
        renderItem={(item, isHighlighted) => (
          <div
            key={Object.keys(item)[0]}
            style={{ background: isHighlighted ? "green" : "black" }}
          >
            {Object.keys(item)[0]}
          </div>
        )}
        value={siteDns}
        onChange={e => onSiteSelect(e.target.value)}
        onSelect={value => onSiteSelect(value)}
      />
    </div>
  );
};

SiteList.propTypes = {};
SiteList.defaultProps = {};

export default SiteList;
